import * as React from "react";
import "./style.scss";
import { SimpleBarChart } from "../../../../core/Chart";
import { processBarChartData } from "../../../../core/Chart/common/utils";
import { Icon } from "antd";
import {
  formatYAxisLabel,
  formatXAxisLabel,
  defaultYTickProps,
  defaultXTickProps,
  defaultYLabelProps,
  defaultXLabelProps
} from "../../../constants";

interface MetricGroupCompareBarChartProps {
  group_by: string;
  compare_by: string;
  metric: string;
  data: any[];
  filterCompareBy?: boolean;
  initialZoom?: BrushPosition;
  onBrushChange?: () => void;
  fullscreen: boolean;
}

export class BarChart extends React.Component<
  MetricGroupCompareBarChartProps,
  {}
> {
  //PURE CSS uses flex box which interferes with recharts' resizableContainer's onscroll width recalculations
  //https://github.com/recharts/recharts/issues/172
  // to work around set width:99%
  render() {
    let {
      group_by,
      compare_by,
      metric,
      data,
      filterCompareBy,
      initialZoom,
      fullscreen
    } = this.props;
    const height = fullscreen ? "90%" : 450;
    let chartData =
      data && data.length > 0
        ? processBarChartData(
            data,
            group_by,
            compare_by,
            metric,
            filterCompareBy
          )
        : null;

    return (
      <div className="analytics-bar-chart" style={{ height: "100%" }}>
        {group_by &&
        group_by != "data" &&
        compare_by &&
        compare_by == "publication" ? (
          <div className="compare-by-warning">
            <Icon type="exclamation-circle" />
            <div style={{ colour: "#979B9F", display: "inline-block" }}>
              {`The data below reflects the top 5 highest performing publications from your selection.`}
            </div>
          </div>
        ) : null}
        {chartData ? (
          <SimpleBarChart
            containerProps={{
              height: height,
              width: "99%"
            }}
            initialZoom={chartData.length > 10 ? initialZoom : null}
            onBrushChange={this.props.onBrushChange}
            chartProps={{
              data: chartData,
              valueKey: metric,
              groupingKey: group_by,
              compareKey: compare_by
            }}
            yAxisProps={{
              labelProps: defaultYLabelProps(metric),
              tickProps: defaultYTickProps
            }}
            xAxisProps={{
              labelProps: defaultXLabelProps(group_by),
              tickProps: defaultXTickProps
            }}
          />
        ) : (
          <div className="null-text">
            <span className="analytics-null-chart">
              There's no data available for the selected dropdowns.
              <br />
              Try changing the dropdowns to view data.
            </span>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/modules/AnalyticsMetric/components/Visualizations/BarChart/index.tsx